module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Italic.f60b4a34.ttf";